export interface DaySegment {
  name: string;
  start: string;
  end: string;
}

export const DaySegments: DaySegment[] = [
  {
    name: "All Day",
    start: "12:00 AM",
    end: "11:59 PM"
  },
  {
    name: "Morning",
    start: "06:00 AM",
    end: "11:59 AM"
  },
  {
    name: "Afternoon",
    start: "12:00 PM",
    end: "05:59 PM"
  },
  {
    name: "Evening",
    start: "06:00 PM",
    end: "10:00 PM"
  },
]